/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import CourseContestManagementDashboard from "src/components/CourseContentManagement/ContestContestAndLinking";
import Navbar from "src/components/Navbar";
import { backendUrlByEnv, LOGIN } from "src/constants/routes";

const CourseContestManagment = () => {
  const navigate = useNavigate();

  const { config: userConfig, env } = useSelector((state) => state?.reducer?.authInfo) || {};

  const ROOT_URL = backendUrlByEnv(env);

  useEffect(() => {
    if (!userConfig?.courseContentManagement?.hasContestManagementAccess) {
      navigate(LOGIN);
    }
  }, []);

  return (
    <>
      <Navbar />
      <CourseContestManagementDashboard ROOT_URL={ROOT_URL} />
    </>
  );
};

export default CourseContestManagment;
